// import { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
// import { Auth } from "aws-amplify";
import { isAuth } from "../apollo/cache";
import { useSelector } from "redux/store";
import {
  PermissionActionValue,
  PermissionFeatureValue,
  selectPermissionAction,
  selectPermissionFeature,
} from "redux/slices/role";
import AccessDenied from "pages/AccessDenied";
import { KeyWhatIsNewType } from "state/useFlag";
import { WhatIsNewByFeature, useWhatIsNewModal } from "sections/whatIsNew";
import { RenderWhatIsNewByFeature } from "WhatIsNew";

// const isAuthenticated = async () => {
//   try {
//     return await Auth.currentSession();
//   } catch (error) {
//     return false;
//   }
// };
type Props = {
  component: any;
  provider: any;
  feature?: PermissionActionValue;
  flagWhatNew?: KeyWhatIsNewType;
};
const PrivateRoute = ({
  component: Component,
  provider: Provider,
  feature,
  flagWhatNew,
  ...rest
}: Props) => {
  // const [loading, setLoading] = useState(true);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const isAuth = await isAuthenticated();
  //     setIsLoggedIn(isAuth);
  //     setLoading(false);
  //   };
  //   fetchData();
  //   return function cleanup() {}
  // }, []);
  const isAllow = feature ? useSelector(selectPermissionAction)(feature) : true;
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth() ? (
          isAllow ? (
            Provider ? (
              <Provider>
                {flagWhatNew && <RenderWhatIsNewByFeature flagWhatNew={flagWhatNew} />}
                <Component {...props} />
              </Provider>
            ) : (
              <>
                {flagWhatNew && <RenderWhatIsNewByFeature flagWhatNew={flagWhatNew} />}
                <Component {...props} />
              </>
            )
          ) : (
            <AccessDenied />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};
export default PrivateRoute;
